import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import Swal from "sweetalert2";

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { filterErrorHandler } from "../../hoc/Shared/utility";
import Select from "../../components/Input/Select/Select";
// import AgentPromoteLinkCreate from "./AgentPromoteLinkCreate";
import AgentPromoteLinkListing from "./AgentPromoteLinkListing";

import { getList, statusPromoteLink } from "../../store/ducks/agentPromoteLink/actions";

const initialFilterInput = {
    domain: '',
    username: '',
    order_id: '',
    status: ''
}

class AgentPromoteLink extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            pageShow: "listing",
            /* datatables / pagination */
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            totalPages: 0,
            totalRecords: 0,
            order: '',
            filterInput: initialFilterInput,
            /* API result array */
            data: [],
            permission: []
        }
    }

    componentDidMount(){
        const listingArr = this.fetchData();
        this.props.getList(listingArr);
    }

    shouldComponentUpdate(nextProps, nextState){
        if(nextState.permission.length===0 && this.props.currentPermission!==undefined){
            this.setState({ permission: this.props.currentPermission });
        }

        if(nextProps.agent_promote_link_list!==undefined && nextProps.agent_promote_link_list!==this.props.agent_promote_link_list){
            if(nextProps.agent_promote_link_list.responseCode===200 && nextProps.agent_promote_link_list.msgType==="success"){
                this.setState({
                    loading: false,
                    data: nextProps.agent_promote_link_list.data.result.row,
                    totalRecords: nextProps.agent_promote_link_list.data.result.pagination.total_record,
                    totalPages: nextProps.agent_promote_link_list.data.result.pagination.total_page
                });
            }
            else {
                this.setState({
                    loading: false,
                    data: [],
                    totalRecords: 0,
                    totalPages: 0,
                    activePage: 1
                }, () => {
                    filterErrorHandler(nextProps.agent_promote_link_list.message);
                });
            }
        }

        if(nextProps.agent_promote_link_status!==undefined && nextProps.agent_promote_link_status!==this.props.agent_promote_link_status){
            if(nextProps.agent_promote_link_status.responseCode===200 && nextProps.agent_promote_link_status.msgType==="success"){
                const { t } = this.props;
                Swal.fire({
                    icon: 'success',
                    title: t('global.success'),
                    html: t('global.record-updated'),
                    showConfirmButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.setState({ loading: true });
                        this.refreshHandler();
                    }
                });
            } else {
                filterErrorHandler(nextProps.agent_promote_link_status.message);   
            }
        }
        return true;
    }

    fetchData = () => {
        const listingArr = {};
        let availablePage = this.state.activePage;

        if (this.state.totalRecords !== 0) {
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            (this.state.activePage >= availablePage) && this.setState({ activePage: availablePage});
        }

        listingArr.page = (this.state.activePage >= availablePage) ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.order = JSON.stringify(this.state.order);
        Object.keys(this.state.filterInput).forEach((val) => {
            listingArr[val] = this.state.filterInput[val];
        });
        return listingArr;
    }

    onInputChange(event) {
        let newFilter = Object.assign({}, this.state.filterInput);
        newFilter[event.target.id] = event.target.value;

        this.setState({
            filterInput: newFilter
        });
    }

    refreshHandler = () => {
        this.setState({ 
            loading: true, 
            data: [],
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            order: '',
        }, () => {
            const listingArr = this.fetchData();
            this.props.getList(listingArr);
        });
    }

    clearHandler = () => {
        this.setState({
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: '',
            loading: true,
            data: [],
            filterInput: initialFilterInput
        }, () => {
            const listingArr = this.fetchData();
            this.props.getList(listingArr);
        });
    }

    changePageHandler = (page) => {
        this.setState({
            pageShow: page
        });
    }

    updateStatus = (event, id) => {
        event.preventDefault();
        const { t } = this.props;
        Swal.fire({
            title: t("global.confirmation"),
            text: t("global.are-you-sure"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t("global.update"),
            cancelButtonText: t("global.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: '',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    onOpen: () => {
                        Swal.showLoading()
                    }
                });

                const data = {};
                data.id = id;
                data.status = Number(event.target.value);
                // console.log("Update Status",data);
                this.props.statusPromoteLink(data);
            }
        });
    }

    // datatable function
    datatablesChangeHandler = (val, act) => {
        this.setState({
            [act]: act === "searchValue" ? val.target.value : val,
            loading: true,
            data: []
        }, () => {
            const listingArr = this.fetchData();
            this.props.getList(listingArr);
        });
    }
    
    noFormatter = (cell, row, rowIndex) => {
        let rowNumber = (this.state.activePage - 1) * this.state.limit + (rowIndex + 1);
        return <span>{rowNumber}</span>;
    }

    changeStatusFormatter = (cell, row) => {
        const { t } = this.props;

        if (this.state.permission.includes("agent_promote_link_update")) {
            let statusArray, dtClassName;
            statusArray = [
                {
                    label: t("global.active"),
                    value: 1,
                    selected: true,
                },
                {
                    label: t("global.inactive"),
                    value: 0,
                },
            ];

            if (row.status === 0) {
                dtClassName = "form-control datatable-select-inactive";
            } else {
                dtClassName = "form-control datatable-select-active";
            }

            return (
                <Select
                    id="status"
                    name="status"
                    options={statusArray}
                    defaultValue={row.status}
                    key={`status-${row.id}`}
                    onChange={(event) => {
                        this.updateStatus(event, row.id)
                    }}
                    className={dtClassName}
                />
            )
        }else{
            let badgeClassName, status;
            if (row.status === 0 || null) {
                badgeClassName = "badge badge-pill badge-danger";
                status = t("global.inactive");
            } else {
                badgeClassName = "badge badge-pill badge-success";
                status = t("global.active");
            }
            return (
                <span className={badgeClassName} key={Math.random()}>{status}</span>
            )
        }
    }

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence = (order === "asc") ? true : false ;

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;

        this.setState({
            order: orderArry,
            loading: true,
            data: [],
        }, () => {
            const listingArr = this.fetchData();
            this.props.getList(listingArr);
        });
    }

    render(){
        const { t } = this.props;
        const columns = [
            { text: t("global.no"), dataField: "no", formatter: this.noFormatter, headerStyle: { width: "60px" } },
            { text: t("agent-promote-link.domain"), dataField: "domain", sort: true, onSort: this.onSort },
            { text: t("agent-promote-link.pricing"), dataField: 'pricing', sort: true, onSort: this.onSort },
            { text: t("agent-promote-link.agent"), dataField: 'username', sort: true, onSort: this.onSort },
            { text: t("agent-promote-link.country"), dataField: 'country', sort: true, onSort: this.onSort },
            { text: t("agent-promote-link.order-id"), dataField: 'order_id', sort: true, onSort: this.onSort },
            { text: t("agent-promote-link.created-at"), dataField: "created_at" },
            { text: t("agent-promote-link.updated-at"), dataField: 'updated_at' },
            { text: t("agent-promote-link.status"), dataField: "status", formatter: this.changeStatusFormatter, headerStyle: { width: "115px"} },
        ];

        let dataListing = this.state.data.map((val, idx) => {
            return {
                id: val.id,
                domain: val.domain,
                pricing: val.pricing,
                username: val.username,
                country: val.country,
                order_id: val.order_id,
                created_at: val.created_at,
                updated_at: val.updated_at,
                status: val.status
            }
        });

        return (
            <Auxiliary>
                {this.state.pageShow==="listing" && (
                    <AgentPromoteLinkListing
                        changePageHandler={(page) => this.changePageHandler(page)}
                        datatablesChangeHandler={(val, act) => this.datatablesChangeHandler(val, act)}
                        onSort={(field, order) => this.onSort(field, order)}
                        refreshHandler={() => this.refreshHandler()}
                        clearHandler={() => this.clearHandler()}
                        onInputChange={(event) => this.onInputChange(event)}
                        filterInput={this.state.filterInput}
                        columns={columns}
                        dataListing={dataListing}
                        activePage={this.state.activePage}
                        limit={this.state.limit}
                        totalRecords={this.state.totalRecords}
                        loading={this.state.loading}
                        permission={this.state.permission}
                    />
                )}

                {/* {this.state.permission.includes("agent_promote_link_create") && this.state.pageShow==="create" && (
                    <AgentPromoteLinkCreate 
                        changePageHandler={(page) => this.changePageHandler(page)}
                        refreshHandler={() => this.refreshHandler()}
                    />
                )} */}
            </Auxiliary>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentPermission: state.currentUser.data.permission,
        agent_promote_link_list: state.agentPromoteLink.agent_promote_link_list,
        agent_promote_link_status: state.agentPromoteLink.agent_promote_link_status
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getList: (data) => dispatch(getList(data)),
        statusPromoteLink: (data) => dispatch(statusPromoteLink(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(AgentPromoteLink));